import React from 'react';

export default function ChatIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 16.4 16.97 20 12 20C10.46 20 9 19.63 7.7 18.97L3 20L4.3 16.1C3.47 14.87 3 13.48 3 12C3 7.6 7.03 4 12 4C16.97 4 21 7.6 21 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="12" r="1" fill={color} />
      <circle cx="12" cy="12" r="1" fill={color} />
      <circle cx="16" cy="12" r="1" fill={color} />
    </svg>
  );
}
